module.exports = __webpack_public_path__ + "img/Business Analyst.111bda1a.png";